// Defaults to chat.clerical.com; override via env for staging/preview.
export const CHAT_HOST: string =
	(import.meta.env.VITE_CHAT_HOST as string | undefined)?.trim() ||
	"chat.clerical.com";

export function isChatHost(): boolean {
	if (typeof window === "undefined") return false;
	return window.location.hostname === CHAT_HOST;
}

/** Absolute URL on the chat subdomain. In dev (no separate host) returns a
 * same-origin relative path for React Router. */
export function chatUrl(path = "/chat"): string {
	const normalized = path.startsWith("/") ? path : `/${path}`;
	if (import.meta.env.DEV || typeof window === "undefined") {
		return normalized;
	}
	return `${window.location.protocol}//${CHAT_HOST}${normalized}`;
}

/** Absolute URL on the main marketing/app host (strip the `chat.` prefix). */
export function mainAppUrl(path: string): string {
	if (typeof window === "undefined") return path;
	const host = window.location.hostname.replace(/^chat\./, "");
	return `${window.location.protocol}//${host}${path}`;
}

/**
 * Allow-list for cross-origin login redirects: only clerical.com's LoginPage
 * redirecting back to the chat subdomain is permitted; everything else is false.
 */
export function isAllowedCrossOriginRedirect(url: string): boolean {
	try {
		const parsed = new URL(url);
		return parsed.hostname === CHAT_HOST;
	} catch {
		return false;
	}
}
